
import { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "sonner";
import { formSchema, FormValues } from "./FormSchema";
import { supabase } from "@/integrations/supabase/client";

export const useFormSubmission = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      nom: "",
      prenom: "",
      email: "",
      telephone: "",
      adresse: "",
      codePostal: "",
      ville: "",
      typeBenne: "",
      typeDechet: "",
      jours: "",
      dateDebut: "",
      commentaire: "",
    },
  });

  const onSubmit = async (values: FormValues) => {
    setIsSubmitting(true);
    console.log("Démarrage de la soumission du formulaire avec values:", JSON.stringify(values));
    
    try {
      // Préparer les données pour l'API
      const requestData = {
        name: `${values.prenom} ${values.nom}`,
        email: values.email,
        phone: values.telephone,
        address: values.adresse,
        postalCode: values.codePostal,
        city: values.ville,
        benneType: values.typeBenne,
        wasteType: values.typeDechet,
        days: values.jours,
        startDate: values.dateDebut,
        comment: values.commentaire || ""
      };

      console.log("Envoi des données à l'API Supabase:", requestData);

      // Appeler la fonction Supabase
      const { data, error } = await supabase.functions.invoke('send-benne-request', {
        body: requestData
      });

      if (error) {
        console.error("Erreur de l'API Supabase:", error);
        throw new Error(error.message || "Erreur lors de l'envoi");
      }

      console.log("Réponse de l'API:", data);
      
      toast.success("Demande envoyée avec succès", {
        description: "Nous avons bien reçu votre demande de location de benne. Notre équipe vous contactera rapidement.",
      });
      
      form.reset();
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Erreur lors de l'envoi", {
        description: "Une erreur s'est produite. Veuillez réessayer ou nous contacter directement par téléphone au 05.65.67.82.05.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    form,
    onSubmit,
    isSubmitting
  };
};
